import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DataService } from './dataService.service';
import {UserInfo} from './userInfo';
import { Observable, observable } from 'rxjs';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  
    _userInfo  =   {}  as UserInfo ;
     EndYear:string;
   
    

  constructor(private dataService:DataService ) {
    
    this.dataService.getUserJson().toPromise().then((result:any)=>{
      this.dataService.userJson = result;
      this.Contruct_userInfo(this.dataService.userJson);
    //  this.valueChange.emit(this.dataService.userJson);
   
    }, err =>{

    });
  
  }
  ngOnInit(): void {
  
  }

  public Contruct_userInfo(result: any): void {
    if(result){
      let sResult = result;
    
    
      this._userInfo= {} as UserInfo;
      this._userInfo.ownerNumber=  result.ownerNumber;
      this._userInfo.ownerWhatsApp=  result.ownerWhatsApp;
      this._userInfo.ownerNumber2= result.ownerNumber2
      this._userInfo.ownerEmail=  result.ownerEmail;
      this._userInfo.storeName= result.storeName;
      this._userInfo.storeLogoPath = result.storeLogoPath;
      this._userInfo.Address = result.Address;
      this._userInfo.Address.Line2present=  result.Address.Line2present;
      this._userInfo.slideImages = result.slideImages;
      this._userInfo.locationUrl= result.LocationUrl;
      console.log(this._userInfo);
      let mydate= new Date();
      this.EndYear= mydate.getFullYear().toString();
    }

  }

 
 
}
